import { render, staticRenderFns } from "./InstoreIcon.vue?vue&type=template&id=0ad2d65b"
import script from "./InstoreIcon.vue?vue&type=script&lang=js"
export * from "./InstoreIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports